import { useEffect } from "react";
import Select from "react-select";

const NEW_VENDOR_VALUE = "12e84755-57e7-4516-aa1e-2d96bb8ae03a-new";

const VendorSelect = (props) => {
  useEffect(() => {
    console.log("props?.selectedVendor", props?.selectedVendor);
  }, [props?.selectedVendor]);

  return (
    <div style={{ width: 240 }}>
      <Select
        key={props?.selectedVendor}
        value={props?.selectedVendor}
        options={[
          {
            value: NEW_VENDOR_VALUE,
            label: <b>+ Add New Vendor</b>,
          },
          ...props?.vendors?.map((vendor) => ({
            value: vendor.id,
            label: vendor.name,
          })),
        ]}
        onChange={(selected) => {
          if (selected.value === NEW_VENDOR_VALUE) {
            props?.onNewVendor();
            return;
          }
          
          const selectedVendor = props?.vendors.find(
            (vendor) => vendor.id === selected?.value
          );
          selectedVendor.label = selectedVendor?.name;
          selectedVendor.value = selectedVendor?.id;

          console.log(selectedVendor);
          props.setSelectedVendor(selectedVendor);
        }}
      />
    </div>
  );
};
export default VendorSelect;
